<template>
    
</template>
<script>
import {WeiXinSettOptionsList} from '../../api/api';

export default {
      data(){
           return {

           }
       },
       methods:
       {

           
           GetWeiXinSettModel(){
                 
           },

       },
      mounted() {
          
     }


}
</script>




// WEBPACK FOOTER //
// WeiXinMain.vue?c394c588